
















































































import {
  LocalNotification,
  localNotificationStorage,
  LocalNotificationStorage,
} from '@/services/local-notification/local-notification-storage'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class LocalNotificationList extends Vue {
  @Prop({ default: () => localNotificationStorage })
  readonly storage: LocalNotificationStorage

  notifications: LocalNotification[] = []

  created() {
    this.reloadNotifications()
    this.unsubscribeStorage = this.storage.subscribe(() => this.reloadNotifications())
  }

  beforeDestroy() {
    this.unsubscribeStorage()
  }

  close(notification: LocalNotification): void {
    this.storage.remove(notification.id)
    this.reloadNotifications()
  }

  classNameForLevel(notification: LocalNotification): string {
    return `c-notification--${notification.level}`
  }

  private unsubscribeStorage: () => void = () => undefined

  private reloadNotifications(): void {
    // 現状は1件しか存在しないが、一般的なUIのバランスを考えて3件を上限と仮置きしている
    const limit = 3
    this.notifications = this.storage.list(limit)
  }
}
